import camelcaseKeys from 'camelcase-keys'

import Api from './fetchApi'

const fetch = async (
  api,
  { data = {}, headers, authToken, method = 'GET' }
) => {
  const fetcher = new Api({ headers, authToken })
  let fetchFunc = fetcher.get

  switch (method.toUpperCase()) {
    case 'POST':
      fetchFunc = fetcher.post
      break
    case 'PUT':
      fetchFunc = fetcher.put
      break
    case 'DELETE':
      fetchFunc = fetcher.delete
  }

  return await fetchFunc(api, data).then(
    data => data && camelcaseKeys(data, { deep: true })
  )
}

export default fetch
